export default __webpack_public_path__ + "d6c91bb81f57c71a5a73d2e8c7be0746.svg";